import { takeLatest, call, put } from 'redux-saga/effects';

import { checkIfAPIResponseIsSuccess } from 'utils/functions/general';

import {
  getDoctorProfiles,
  updateDoctorLicenceStatus,
  assignDoctorBadges,
  revokeDoctorBadges,
} from './api';
import {
  fetchDoctorsListSuccess,
  fetchDoctorsListFail,
  fetchUpdateDoctorLicenceStatusSuccess,
  fetchUpdateDoctorLicenceStatusFail,
  fetchAssignOrRevokeDoctorBadgesSuccess,
  fetchAssignOrRevokeDoctorBadgesFail,
} from './actions';
import doctorsActionTypes from './action-types';

function* fetchDoctorsListSaga({ payload }) {
  try {
    const response = yield call(getDoctorProfiles, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    yield put(fetchDoctorsListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchDoctorsListFail(error));
  }
}

function* fetchUpdateDoctorLicenceStatusSaga({ payload }) {
  const { actionPopupCallbackAction } = payload;

  try {
    const response = yield call(updateDoctorLicenceStatus, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    actionPopupCallbackAction(true);
    yield put(fetchUpdateDoctorLicenceStatusSuccess(response.data.data));
  } catch (error) {
    actionPopupCallbackAction();
    yield put(fetchUpdateDoctorLicenceStatusFail(error));
  }
}

function* fetchAssignOrRevokeDoctorBadgesSaga({ payload }) {
  const { isAssign, badgePopupCallbackAction } = payload;

  try {
    let response;
    if (isAssign) response = yield call(assignDoctorBadges, payload);
    else response = yield call(revokeDoctorBadges, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    badgePopupCallbackAction(true);
    yield put(fetchAssignOrRevokeDoctorBadgesSuccess(response.data.data));
  } catch (error) {
    badgePopupCallbackAction();
    yield put(fetchAssignOrRevokeDoctorBadgesFail(error));
  }
}

function* doctorsSaga() {
  yield takeLatest(doctorsActionTypes.FETCH_DOCTORS_LIST, fetchDoctorsListSaga);
  yield takeLatest(
    doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS,
    fetchUpdateDoctorLicenceStatusSaga,
  );
  yield takeLatest(
    doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES,
    fetchAssignOrRevokeDoctorBadgesSaga,
  );
}

export default doctorsSaga;
